import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  fr: {
    nav: { home: "Accueil", products: "Produits", about: "À propos", testimonials: "Témoignages", faq: "FAQ", contact: "Contact", cta: "Voir les modèles" },
    footer: {
      tagline: "Tapis d'auto moulés en 3D, taillés pour l'hiver — et parfaits les 4 saisons. Conçus pour le Nord, testés à -40 °C, garantis à vie.",
      nordic: "Protection nordique",
      productCol: "Le produit",
      companyCol: "Compagnie",
      contactCol: "Nous joindre",
      mat: "Le tapis Sur-Mesure 3D",
      order: "Commander",
      findVehicle: "Trouver mon véhicule",
      compat: "Compatibilité (FAQ)",
      policies: "Retours & garantie",
      hours: "Lun – Ven · 8 h à 18 h",
      response: "Réponse garantie en moins de 2 h ouvrables",
      rights: "© 2026 NordiGuard — La protection hivernale ultime pour votre voiture.",
    },
    vehicle: { brand: "Marque", model: "Modèle", modelFirst: "Choisissez d'abord la marque", year: "Année" },
    marquee: ["Qualité nordique", "Sur-mesure 3D", "Étanchéité totale", "Garantie à vie", "TPE recyclable", "Rebords de 5 cm"],
    beforeAfter: { before: "AVANT", after: "APRÈS" },
    home: {
      badge: "Taillés pour l'hiver — parfaits 4 saisons",
      l1: "LA PROTECTION", l2: "HIVERNALE", l3: "ULTIME.",
      sub: "NordiGuard — la protection ultime pour votre voiture, hiver comme été. Des tapis moulés au millimètre qui capturent la neige, la slush et le sel l'hiver, puis la boue, l'eau de pluie et le sable le reste de l'année.",
      cta1: "Voir les modèles", cta2: "Découvrir la technologie",
      stats: [
        { value: "-40 °C", label: "Testé en conditions réelles" },
        { value: "5 cm", label: "Rebords de rétention" },
        { value: "100 %", label: "Étanche — garanti à vie" },
        { value: "30 s", label: "Nettoyage au jet d'eau" },
      ],
      finderTitle: "Trouvez le tapis moulé pour votre véhicule",
      finderEmpty: "Toutes les marques et modèles de 2015 à aujourd'hui. Sélectionnez votre véhicule.",
      finderFound: "Recommandé pour votre {vehicle} : NordiGuard Sur-Mesure 3D — ajustement laser garanti.",
      finderCta: "Voir le tapis recommandé",
      showEyebrow: "L'ensemble complet",
      showTitle: "Pensé comme un équipement d'origine",
      show1: "L'ensemble au complet : 2 tapis avant + tapis arrière d'une seule pièce",
      show2: "L'eau perle et reste prisonnière des rainures — votre moquette reste sèche",
      show3: "Des hivers sereins, au volant",
      benefitsEyebrow: "Avantages NordiGuard",
      benefitsTitle: "Quatre lignes de défense, quatre saisons",
      benefits: [
        { title: "100 % étanche", text: "Un bac intégral qui retient jusqu'à 3,5 L d'eau de fonte. Votre moquette reste sèche, peu importe la tempête." },
        { title: "Anti-sel & anti-calcium", text: "Le TPE NordiGuard est inerte face au sel de déglaçage. Fini les traces blanches définitives sur les planchers." },
        { title: "Anti-neige extrême", text: "Flexible jusqu'à -40 °C, sans fissure ni durcissement. Conçu pour les hivers les plus rudes du Nord." },
        { title: "Nettoyage au jet d'eau", text: "Retirez, rincez, replacez. Trente secondes chrono, et le tapis est prêt pour la prochaine bordée." },
      ],
      baEyebrow: "La différence NordiGuard",
      baTitle1: "Une moquette détrempée.", baTitle2: "Ou un bouclier impeccable.",
      baText: "Chaque hiver, la slush fond sur vos planchers et le sel s'incruste dans les fibres. Glissez le curseur : à gauche, une moquette après une saison. À droite, le même plancher protégé par un tapis 3D NordiGuard.",
      baBullets: ["Retient 3,5 L d'eau de fonte par tapis", "Bloque le sel et le calcium de déglaçage", "Préserve la valeur de revente du véhicule"],
      whyEyebrow: "Pourquoi NordiGuard ?",
      whyTitle: "L'ingénierie nordique, jusqu'au dernier millimètre",
      why1t: "Scan laser 3D du plancher",
      why1x: "Chaque véhicule est numérisé au laser. Le tapis épouse le plancher au dixième de millimètre — seuils, tunnel central, contours de pédales inclus.",
      why2t: "Rebords surélevés de 5 cm",
      why2x: "Un véritable bac de rétention : l'eau de fonte et la slush restent prisonnières du tapis.",
      why3: [
        { title: "TPE 100 % recyclable", text: "Un matériau premium sans PVC ni odeur, recyclable en fin de vie. Robuste pour vous, responsable pour le Nord." },
        { title: "Fixation antidérapante", text: "Picots d'ancrage haute densité et clips compatibles avec les fixations d'origine. Le tapis ne bouge jamais." },
        { title: "-40 °C sans fissure", text: "Le TPE NordiGuard reste souple et silencieux aux températures les plus extrêmes, saison après saison." },
      ],
      featuredEyebrow: "Le tapis NordiGuard",
      featuredTitle1: "Un seul tapis.", featuredTitle2: "Le vôtre.",
      viewAll: "Tout le catalogue",
      perSet: "ensemble complet avant + arrière une pièce",
      discover: "Découvrir le tapis",
      finalTitle: "L'HIVER N'ATTEND PAS.",
      finalText: "Chaque bordée de neige qui fond sur votre moquette laisse sa marque. Équipez votre véhicule avant la prochaine tempête.",
      finalCta1: "Voir les modèles", finalCta2: "Parler à un expert",
    },
    products: {
      eyebrow: "Le tapis NordiGuard",
      l1: "UN SEUL TAPIS.", l2: "LE VÔTRE.",
      sub: "Pas de gamme compliquée : un seul modèle premium, numérisé au laser puis moulé pour le plancher exact de votre véhicule. Choisissez votre voiture, on s'occupe du reste.",
      vehTitle: "Votre véhicule",
      vehSub: "Toutes les marques et modèles de 2015 à aujourd'hui.",
      bannerOk: "Parfait — votre {vehicle} ({category}) sera numérisé au laser et votre ensemble Sur-Mesure 3D moulé au millimètre pour son plancher exact.",
      yourVehicle: "Votre véhicule",
      reviewsSuffix: "avis",
      perSet: "ensemble complet avant + arrière une pièce",
      order: "Commander",
      details: "Fiche complète",
      fabEyebrow: "Fabrication sur mesure",
      fabTitle: "Chaque détail est pensé pour durer",
      fabText: "Bords finis à la main, clips latéraux pour une installation sécurisée, couche supérieure en PVC 100 % imperméable, dessous en tissu antidérapant et rainures anti-glisse profondes : le Sur-Mesure 3D assemble cinq lignes de défense en un seul ensemble — deux tapis avant et un tapis arrière d'une seule pièce.",
      fabLink: "Notre engagement qualité",
    },
    detail: {
      back: "Retour au catalogue",
      reviewsSuffix: "avis vérifiés",
      perSet: "ensemble complet avant + arrière",
      order: "Commander maintenant",
      question: "Une question ?",
      trust1: "Compatibilité garantie", trust2: "Expédition sous 24 h", trust3: "Garantie à vie",
      checkTitle: "Vérifiez votre véhicule",
      checkOk: "Compatibilité confirmée — votre {vehicle} ({category}) sera numérisé au laser et votre ensemble Sur-Mesure 3D moulé au millimètre pour son plancher exact.",
      compatTitle: "Compatibilité vérifiée",
      compatSub: "Moulé à partir du scan laser de votre plancher :",
      specsTitle: "Spécifications",
      fabEyebrow: "Fabrication sur mesure",
      fabTitle: "Cinq lignes de défense, un seul ensemble",
      fabText: "Bords finis professionnels, clips latéraux d'installation sécurisée, couche supérieure en PVC 100 % imperméable et durable, dessous en tissu antidérapant, rainures anti-glisse profondes : chaque ensemble Sur-Mesure 3D est produit pour votre plancher exact — deux tapis avant et un tapis arrière d'une seule pièce.",
      baTitle1: "Avant / après —", baTitle2: "la preuve en image",
      baSub: "Glissez le curseur pour comparer une moquette exposée à l'hiver et le même plancher protégé par un tapis NordiGuard.",
      notFound: "Modèle introuvable",
      notFoundSub: "Ce tapis n'existe pas (ou plus) dans le catalogue.",
      backCatalog: "Retour au catalogue",
      urgency: "Production lancée sous 48 h — commandez avant le prochain épisode de neige",
    },
    policies: {
      eyebrow: "Nos engagements",
      l1: "RETOURS &", l2: "GARANTIE.",
      sub: "Acheter un tapis NordiGuard, c'est être protégé deux fois : sur la route et après l'achat.",
      retTitle: "Politique de retour — 30 jours",
      retPoints: [
        "Vous disposez de 30 jours après la livraison pour retourner votre ensemble, non utilisé et dans son emballage d'origine.",
        "Si l'ajustement n'est pas parfait sur votre véhicule, nous reproduisons le tapis gratuitement ou nous vous remboursons intégralement.",
        "Le remboursement est émis sur le mode de paiement d'origine sous 5 jours ouvrables après réception du retour.",
        "Écrivez à info@nordiguard.com avec votre numéro de commande pour obtenir votre étiquette de retour.",
      ],
      garTitle: "Garantie de qualité à vie",
      garPoints: [
        "Couvre les fissures, la déformation, la perte de flexibilité au froid et tout défaut de fabrication.",
        "Valide tant que vous êtes propriétaire du véhicule associé à la commande.",
        "Remplacement gratuit, sans frais de livraison, sur simple photo du défaut.",
        "Ne couvre pas : coupures, brûlures, modification du produit ou usage hors spécifications.",
      ],
      safetyTitle: "Rappel de sécurité",
      cta: "Une question ? Contactez-nous",
    },
    about: {
      eyebrow: "À propos de NordiGuard",
      l1: "L'HIVER NOUS A", l2: "RENDUS", l3: "OBSESSIONNELS.",
      sub: "Notre mission est simple : qu'aucun conducteur du Nord ne perde jamais une moquette, une valeur de revente ou une matinée à cause de la neige fondue. Nous concevons la meilleure protection de plancher au monde — et rien d'autre.",
      historyEyebrow: "Notre histoire",
      historyTitle: "Du premier flocon à la perfection",
      timeline: [
        { year: "2018", title: "Nés dans le froid", text: "Après un hiver de trop passé à sécher des moquettes trempées, nos fondateurs décident de concevoir le tapis que l'industrie refusait de fabriquer." },
        { year: "2020", title: "Le scan laser 3D", text: "Nous numérisons notre premier parc de 200 véhicules au laser. La découpe au millimètre devient notre signature." },
        { year: "2022", title: "Le TPE recyclable", text: "Adieu le PVC : notre formulation TPE premium est 100 % recyclable, sans odeur et flexible à -40 °C." },
        { year: "2025", title: "100 000 véhicules protégés", text: "Du Yukon à la Côte-Nord, plus de cent mille conducteurs roulent l'hiver sans jamais penser à leurs planchers." },
      ],
      valuesEyebrow: "Nos engagements",
      valuesTitle: "Ce en quoi nous croyons",
      values: [
        { title: "Précision obsessionnelle", text: "Chaque tapis naît d'une numérisation laser du plancher exact de votre véhicule. Pas « à peu près » — au dixième de millimètre." },
        { title: "Qualité sans compromis", text: "Chaque lot est testé au froid, à l'abrasion et au sel avant expédition. Si ça ne survit pas à nos tests, ça ne porte pas notre nom." },
        { title: "Fabrication durable", text: "TPE 100 % recyclable, production à faible énergie et emballages en carton recyclé. Protéger votre voiture ne doit pas coûter la planète." },
        { title: "Le Nord comme laboratoire", text: "Nos prototypes sont testés dans de vrais blizzards, sur de vraies routes salées. L'hiver est notre banc d'essai." },
      ],
      durTitle: "La fabrication durable n'est pas une option",
      durText: "Un tapis NordiGuard dure toute la vie de votre véhicule — et au-delà : notre programme de reprise recycle chaque tapis usagé en nouvelle matière première. Moins de déchets, plus d'hivers protégés.",
      durText2: "Trois couches assemblées à vie : dessus en PVC texturé durable, âme en EVA souple et absorbante, dessous en tissu antidérapant à friction maximale.",
      cta: "Découvrir la gamme",
    },
    faq: {
      eyebrow: "Centre d'aide",
      title: "QUESTIONS FRÉQUENTES",
      sub: "Entretien, compatibilité, livraison, garantie — tout ce qu'il faut savoir avant de commander.",
      search: "Rechercher une question…",
      cats: { toutes: "Toutes", entretien: "Entretien", compatibilite: "Compatibilité", livraison: "Livraison", garantie: "Garantie" },
      empty: "Aucune question ne correspond à votre recherche.",
      stillTitle: "Toujours sans réponse ?",
      stillSub: "Notre équipe répond en moins de 2 h ouvrables.",
      cta: "Nous contacter",
    },
    testimonials: {
      eyebrow: "Témoignages",
      l1: "APPROUVÉ PAR", l2: "LE VRAI HIVER.",
      stats: ["Note moyenne", "Avis vérifiés", "Recommandent NordiGuard"],
      verified: "Achat vérifié",
      modelPrefix: "Modèle",
      shareQ: "Vous roulez déjà avec NordiGuard ?",
      shareCta: "Partagez votre expérience",
    },
    contact: {
      eyebrow: "Contact",
      l1: "PARLONS", l2: "PROTECTION.",
      name: "Nom complet", email: "Courriel", subjectPh: "Sujet de votre message",
      subjects: ["Vérifier la compatibilité de mon véhicule", "Question sur une commande", "Conseil d'entretien", "Demande de garantie", "Autre"],
      messagePh: "Votre message (précisez marque, modèle et année du véhicule pour une réponse plus rapide)…",
      send: "Envoyer le message", sending: "Envoi en cours…",
      toastOk: "Message envoyé !", toastOkSub: "Notre équipe vous répond en moins de 2 h ouvrables.",
      toastErr: "Une erreur est survenue. Veuillez réessayer.",
      emailTitle: "Courriel", hoursTitle: "Heures d'ouverture", hoursVal: "Lundi au vendredi · 8 h à 18 h",
      responseTitle: "Réponse rapide", responseVal: "Garantie de réponse en moins de 2 h ouvrables",
      mapLabel: "NordiGuard — Québec, Canada",
    },
    checkout: {
      eyebrow: "Commande sécurisée",
      l1: "FINALISER", l2: "MA COMMANDE.",
      steps: ["Véhicule", "Coordonnées", "Paiement"],
      vehTitle: "Votre véhicule",
      vehSub: "Le tapis sera moulé pour ce plancher exact.",
      continue: "Continuer",
      back: "Retour",
      contactTitle: "Coordonnées & livraison",
      name: "Nom complet", email: "Courriel", phone: "Téléphone",
      address: "Adresse de livraison complète (rue, ville, province, code postal)",
      street: "Adresse (n° et rue)",
      apartment: "Appartement, bureau (optionnel)",
      city: "Ville",
      postalCode: "Code postal",
      postalHint: "Format : A1A 1A1",
      postalInvalid: "Code postal canadien invalide",
      taxes: "Taxes",
      qty: "Quantité",
      summaryTitle: "Résumé de la commande",
      receiveTitle: "Ce que vous recevrez",
      receive: [
        "2 tapis avant moulés au millimètre pour votre véhicule",
        "1 tapis arrière d'une seule pièce couvrant le tunnel central",
        "Clips d'installation compatibles avec les fixations d'origine",
        "Guide d'installation et d'entretien",
        "Carte de garantie à vie NordiGuard",
      ],
      safetyTitle: "Consignes de sécurité",
      safety: [
        "Ne jamais superposer le tapis sur un autre tapis ou sur la moquette d'origine mal fixée.",
        "Toujours fixer le tapis conducteur avec les clips fournis avant de prendre la route.",
        "Vérifier qu'aucune partie du tapis n'interfère avec les pédales (frein, accélérateur, embrayage).",
        "Retirer et replacer le tapis correctement après chaque nettoyage.",
      ],
      total: "Total", shipping: "Livraison standard", free: "Gratuite", taxNote: "Taxes canadiennes calculées selon votre province.",
      subtotal: "Sous-total",
      province: "Province / territoire",
      provincePlaceholder: "Choisir votre province…",
      payBtn: "Confirmer ma commande",
      processing: "Envoi de votre commande…",
      secureNote: "Virement Interac : instructions envoyées après confirmation. Cartes, PayPal et Apple Pay : paiement chiffré, aucune donnée conservée ici.",
      methodTitle: "Mode de paiement",
      methodCard: "Carte de crédit",
      methodCardSub: "Visa, Mastercard, American Express",
      methodInterac: "Virement Interac",
      methodInteracSub: "Simple et sans frais — instructions envoyées après confirmation",
      methodPaypal: "PayPal",
      methodPaypalSub: "Payez avec votre compte PayPal",
      methodApplePay: "Apple Pay",
      methodApplePaySub: "Paiement rapide sur iPhone, iPad et Mac",
      methodSoon: "Bientôt disponible",
      paypalHint: "Créez votre commande, puis finalisez avec PayPal ci-dessous.",
      changeVehicle: "Modifier",
      errVehicle: "Veuillez choisir la marque et le modèle de votre véhicule.",
      errPay: "Impossible d'envoyer la commande. Réessayez.",
    },
    success: {
      checking: "Chargement de votre commande…",
      eyebrow: "Commande confirmée",
      title1: "Votre véhicule passe",
      title2: "en mode hiver.",
      tracker: ["Commandée", "Expédiée", "Livrée"],
      greeting: "Bonjour {name},",
      intro: "Votre commande a été confirmée — merci d'avoir choisi NordiGuard. Suivez votre commande en temps réel ici même.",
      nextTitle: "Prochaines étapes",
      next: [
        "La plupart des commandes sont expédiées sous 2 jours ouvrables.",
        "Chaque ensemble NordiGuard est moulé au laser pour votre véhicule précis.",
        "Satisfait de l'expérience? Parlez de NordiGuard à quelqu'un qui remarque les détails, lui aussi.",
      ],
      summaryTitle: "Résumé",
      orderNumber: "N° de commande",
      orderDate: "Date de commande",
      totalTitle: "Total de la commande",
      homeCta: "Retour à l'accueil",
      code: "Code de confirmation",
      codeNote: "Conservez ce code — il figure sur votre facture et dans votre courriel de confirmation.",
      invoiceCta: "Télécharger ma facture (PDF)",
      notFound: "Commande introuvable. Vérifiez votre lien ou contactez-nous.",
      interacTitle: "Dernière étape : votre virement Interac",
      interacStep1: "Envoyez un virement Interac de",
      interacStep2: "Inscrivez votre code dans le message du virement :",
      interacStep3: "La production démarre dès réception — vous recevrez le suivi par courriel.",
      tracking: "Numéro de suivi",
      liveNote: "Cette page se met à jour automatiquement.",
    },
    interac: {
      title: "Virement Interac",
      subtitle: "Commande réservée — il ne reste que le virement.",
      stepBank: "1. Connectez-vous à votre banque",
      stepBankSub: "Choisissez votre institution ci-dessous — une nouvelle fenêtre s'ouvre sur sa page de connexion sécurisée.",
      stepSend: "2. Envoyez le virement",
      sendTo: "Destinataire",
      sendAmount: "Montant exact",
      sendMessage: "Message du virement (important)",
      stepDone: "3. C'est tout",
      stepDoneSub: "La production démarre dès réception. Votre confirmation et votre suivi arrivent par courriel.",
      confirmCta: "Voir ma confirmation de commande",
      secureNote: "Vous effectuez le virement sur le site sécurisé de votre banque — NordiGuard ne voit jamais vos données bancaires.",
    },
    lang: { label: "EN" },
    admin: {
      title: "Gestion des commandes",
      subtitle: "Espace privé NordiGuard",
      password: "Mot de passe administrateur",
      login: "Se connecter",
      wrong: "Mot de passe incorrect",
      logout: "Déconnexion",
      refresh: "Actualiser",
      empty: "Aucune commande pour l'instant.",
      status: {
        commandee: "Commandée",
        recue: "Payée — en production",
        en_attente_virement: "Virement attendu",
        en_attente_paiement: "Paiement en ligne attendu",
        payee: "Payée — en production",
        expediee: "Expédiée",
        livree: "Livrée",
      },
      actPaid: "Virement reçu",
      actShip: "Marquer expédiée",
      actDeliver: "Marquer livrée",
      trackingPlaceholder: "Numéro de suivi (optionnel)",
      shippedNote: "Le client a été avisé par courriel.",
    },
    marketing: {
      tagline: "Tapis d'auto 5D en PVC personnalisable avec base en EVA pour habitacle",
    },
  },
  en: {
    nav: { home: "Home", products: "Products", about: "About", testimonials: "Reviews", faq: "FAQ", contact: "Contact", cta: "See the mat" },
    footer: {
      tagline: "3D-molded car floor mats, built for winter — and perfect all 4 seasons. Designed for the North, tested at -40 °C, guaranteed for life.",
      nordic: "Nordic protection",
      productCol: "The product",
      companyCol: "Company",
      contactCol: "Get in touch",
      mat: "The Sur-Mesure 3D mat",
      order: "Order",
      findVehicle: "Find my vehicle",
      compat: "Compatibility (FAQ)",
      policies: "Returns & warranty",
      hours: "Mon – Fri · 8 AM to 6 PM",
      response: "Guaranteed reply within 2 business hours",
      rights: "© 2026 NordiGuard — The ultimate winter protection for your car.",
    },
    vehicle: { brand: "Make", model: "Model", modelFirst: "Choose a make first", year: "Year" },
    marquee: ["Nordic quality", "3D custom-fit", "Fully waterproof", "Lifetime warranty", "Recyclable TPE", "5 cm edges"],
    beforeAfter: { before: "BEFORE", after: "AFTER" },
    home: {
      badge: "Built for winter — perfect all 4 seasons",
      l1: "THE ULTIMATE", l2: "WINTER", l3: "PROTECTION.",
      sub: "NordiGuard — the ultimate protection for your car, in winter and beyond. Mats molded to the millimetre that trap snow, slush and salt in winter, then mud, rain and sand the rest of the year.",
      cta1: "See the mat", cta2: "Discover the technology",
      stats: [
        { value: "-40 °C", label: "Tested in real conditions" },
        { value: "5 cm", label: "Retention edges" },
        { value: "100 %", label: "Waterproof — lifetime warranty" },
        { value: "30 s", label: "Hose-off cleaning" },
      ],
      finderTitle: "Find the molded mat for your vehicle",
      finderEmpty: "Every make and model from 2015 to today. Select your vehicle.",
      finderFound: "Recommended for your {vehicle}: NordiGuard Sur-Mesure 3D — laser fit guaranteed.",
      finderCta: "See the recommended mat",
      showEyebrow: "The complete set",
      showTitle: "Designed like factory equipment",
      show1: "The full set: 2 front mats + one-piece rear mat",
      show2: "Water beads and stays trapped in the grooves — your carpet stays dry",
      show3: "Serene winters, behind the wheel",
      benefitsEyebrow: "NordiGuard advantages",
      benefitsTitle: "Four lines of defence, four seasons",
      benefits: [
        { title: "100% waterproof", text: "A full-coverage tray that holds up to 3.5 L of meltwater. Your carpet stays dry, whatever the storm." },
        { title: "Salt & calcium proof", text: "NordiGuard TPE is inert to road salt. No more permanent white stains on your floors." },
        { title: "Extreme snow resistance", text: "Flexible down to -40 °C, with no cracking or hardening. Built for the harshest northern winters." },
        { title: "Hose-off cleaning", text: "Remove, rinse, replace. Thirty seconds flat, and the mat is ready for the next snowfall." },
      ],
      baEyebrow: "The NordiGuard difference",
      baTitle1: "A soaked carpet.", baTitle2: "Or a spotless shield.",
      baText: "Every winter, slush melts onto your floors and salt works its way into the fibres. Drag the slider: on the left, a carpet after one season. On the right, the same floor protected by a NordiGuard 3D mat.",
      baBullets: ["Holds 3.5 L of meltwater per mat", "Blocks road salt and calcium", "Preserves your vehicle's resale value"],
      whyEyebrow: "Why NordiGuard?",
      whyTitle: "Nordic engineering, down to the last millimetre",
      why1t: "3D laser floor scanning",
      why1x: "Every vehicle is laser-scanned. The mat hugs the floor to a tenth of a millimetre — sills, center tunnel and pedal contours included.",
      why2t: "5 cm raised edges",
      why2x: "A true retention tray: meltwater and slush stay trapped inside the mat.",
      why3: [
        { title: "100% recyclable TPE", text: "A premium PVC-free, odorless material, recyclable at end of life. Tough for you, responsible for the North." },
        { title: "Anti-slip retention", text: "High-density anchoring spikes and factory-compatible clips. The mat never moves." },
        { title: "-40 °C without cracking", text: "NordiGuard TPE stays flexible and silent in the most extreme temperatures, season after season." },
      ],
      featuredEyebrow: "The NordiGuard mat",
      featuredTitle1: "One mat.", featuredTitle2: "Yours.",
      viewAll: "Full catalogue",
      perSet: "complete set: front + one-piece rear",
      discover: "Discover the mat",
      finalTitle: "WINTER WON'T WAIT.",
      finalText: "Every snowfall that melts on your carpet leaves its mark. Equip your vehicle before the next storm.",
      finalCta1: "See the mat", finalCta2: "Talk to an expert",
    },
    products: {
      eyebrow: "The NordiGuard mat",
      l1: "ONE MAT.", l2: "YOURS.",
      sub: "No complicated lineup: one premium model, laser-scanned then molded for your vehicle's exact floor. Pick your car, we handle the rest.",
      vehTitle: "Your vehicle",
      vehSub: "Every make and model from 2015 to today.",
      bannerOk: "Perfect — your {vehicle} ({category}) will be laser-scanned and your Sur-Mesure 3D set molded to the millimetre for its exact floor.",
      yourVehicle: "Your vehicle",
      reviewsSuffix: "reviews",
      perSet: "complete set: front + one-piece rear",
      order: "Order now",
      details: "Full details",
      fabEyebrow: "Custom manufacturing",
      fabTitle: "Every detail is built to last",
      fabText: "Hand-finished edges, side clips for a secure installation, a 100% waterproof PVC top layer, anti-slip fabric backing and deep anti-slip grooves: the Sur-Mesure 3D packs five lines of defence into one set — two front mats and a one-piece rear mat.",
      fabLink: "Our quality commitment",
    },
    detail: {
      back: "Back to catalogue",
      reviewsSuffix: "verified reviews",
      perSet: "complete front + rear set",
      order: "Order now",
      question: "A question?",
      trust1: "Fit guaranteed", trust2: "Ships within 24 h", trust3: "Lifetime warranty",
      checkTitle: "Check your vehicle",
      checkOk: "Compatibility confirmed — your {vehicle} ({category}) will be laser-scanned and your Sur-Mesure 3D set molded to the millimetre for its exact floor.",
      compatTitle: "Verified compatibility",
      compatSub: "Molded from a laser scan of your floor:",
      specsTitle: "Specifications",
      fabEyebrow: "Custom manufacturing",
      fabTitle: "Five lines of defence, one set",
      fabText: "Professionally finished edges, secure side installation clips, a durable 100% waterproof PVC top layer, anti-slip fabric backing and deep anti-slip grooves: every Sur-Mesure 3D set is produced for your exact floor — two front mats and a one-piece rear mat.",
      baTitle1: "Before / after —", baTitle2: "the proof in pictures",
      baSub: "Drag the slider to compare a winter-exposed carpet with the same floor protected by a NordiGuard mat.",
      notFound: "Model not found",
      notFoundSub: "This mat doesn't exist (anymore) in the catalogue.",
      backCatalog: "Back to catalogue",
      urgency: "Production starts within 48 h — order before the next snowfall",
    },
    policies: {
      eyebrow: "Our commitments",
      l1: "RETURNS &", l2: "WARRANTY.",
      sub: "Buying a NordiGuard mat means being protected twice: on the road and after the purchase.",
      retTitle: "Return policy — 30 days",
      retPoints: [
        "You have 30 days after delivery to return your set, unused and in its original packaging.",
        "If the fit isn't perfect on your vehicle, we re-make the mat free of charge or refund you in full.",
        "Refunds are issued to the original payment method within 5 business days of receiving the return.",
        "Email info@nordiguard.com with your order number to get your return label.",
      ],
      garTitle: "Lifetime quality warranty",
      garPoints: [
        "Covers cracks, warping, loss of cold flexibility and any manufacturing defect.",
        "Valid for as long as you own the vehicle associated with the order.",
        "Free replacement, shipping included, with a simple photo of the defect.",
        "Not covered: cuts, burns, product modification or out-of-spec use.",
      ],
      safetyTitle: "Safety reminder",
      cta: "A question? Contact us",
    },
    about: {
      eyebrow: "About NordiGuard",
      l1: "WINTER MADE US", l2: "DOWNRIGHT", l3: "OBSESSIVE.",
      sub: "Our mission is simple: no northern driver should ever lose a carpet, resale value or a morning to melted snow. We design the best floor protection in the world — and nothing else.",
      historyEyebrow: "Our story",
      historyTitle: "From first snowflake to perfection",
      timeline: [
        { year: "2018", title: "Born in the cold", text: "After one winter too many spent drying soaked carpets, our founders decided to build the mat the industry refused to make." },
        { year: "2020", title: "3D laser scanning", text: "We laser-scan our first fleet of 200 vehicles. Millimetre-perfect cutting becomes our signature." },
        { year: "2022", title: "Recyclable TPE", text: "Goodbye PVC: our premium TPE formula is 100% recyclable, odorless and flexible to -40 °C." },
        { year: "2025", title: "100,000 protected vehicles", text: "From Yukon to the North Shore, over a hundred thousand drivers ride all winter without ever thinking about their floors." },
      ],
      valuesEyebrow: "Our commitments",
      valuesTitle: "What we believe in",
      values: [
        { title: "Obsessive precision", text: "Every mat starts with a laser scan of your vehicle's exact floor. Not 'close enough' — to a tenth of a millimetre." },
        { title: "Uncompromising quality", text: "Every batch is cold-tested, abrasion-tested and salt-tested before shipping. If it can't survive our tests, it doesn't wear our name." },
        { title: "Sustainable manufacturing", text: "100% recyclable TPE, low-energy production and recycled-cardboard packaging. Protecting your car shouldn't cost the planet." },
        { title: "The North as our lab", text: "Our prototypes are tested in real blizzards, on real salted roads. Winter is our test bench." },
      ],
      durTitle: "Sustainable manufacturing is not an option",
      durText: "A NordiGuard mat lasts the life of your vehicle — and beyond: our take-back program recycles every used mat into new raw material. Less waste, more protected winters.",
      durText2: "Three permanently bonded layers: a durable textured PVC top, a soft shock-absorbing EVA core, and a maximum-grip anti-slip fabric backing.",
      cta: "Discover the mat",
    },
    faq: {
      eyebrow: "Help centre",
      title: "FREQUENTLY ASKED QUESTIONS",
      sub: "Care, compatibility, shipping, warranty — everything you need to know before ordering.",
      search: "Search a question…",
      cats: { toutes: "All", entretien: "Care", compatibilite: "Compatibility", livraison: "Shipping", garantie: "Warranty" },
      empty: "No question matches your search.",
      stillTitle: "Still no answer?",
      stillSub: "Our team replies within 2 business hours.",
      cta: "Contact us",
    },
    testimonials: {
      eyebrow: "Reviews",
      l1: "APPROVED BY", l2: "REAL WINTER.",
      stats: ["Average rating", "Verified reviews", "Recommend NordiGuard"],
      verified: "Verified purchase",
      modelPrefix: "Model",
      shareQ: "Already driving with NordiGuard?",
      shareCta: "Share your experience",
    },
    contact: {
      eyebrow: "Contact",
      l1: "LET'S TALK", l2: "PROTECTION.",
      name: "Full name", email: "Email", subjectPh: "Subject of your message",
      subjects: ["Check my vehicle's compatibility", "Question about an order", "Care advice", "Warranty claim", "Other"],
      messagePh: "Your message (include make, model and year for a faster answer)…",
      send: "Send message", sending: "Sending…",
      toastOk: "Message sent!", toastOkSub: "Our team replies within 2 business hours.",
      toastErr: "Something went wrong. Please try again.",
      emailTitle: "Email", hoursTitle: "Business hours", hoursVal: "Monday to Friday · 8 AM to 6 PM",
      responseTitle: "Fast reply", responseVal: "Guaranteed reply within 2 business hours",
      mapLabel: "NordiGuard — Quebec City, Canada",
    },
    checkout: {
      eyebrow: "Secure checkout",
      l1: "COMPLETE", l2: "MY ORDER.",
      steps: ["Vehicle", "Your details", "Payment"],
      vehTitle: "Your vehicle",
      vehSub: "The mat will be molded for this exact floor.",
      continue: "Continue",
      back: "Back",
      contactTitle: "Contact & shipping details",
      name: "Full name", email: "Email", phone: "Phone",
      address: "Full shipping address (street, city, province, postal code)",
      street: "Street address (no. and street)",
      apartment: "Apartment, suite (optional)",
      city: "City",
      postalCode: "Postal code",
      postalHint: "Format: A1A 1A1",
      postalInvalid: "Invalid Canadian postal code",
      taxes: "Taxes",
      qty: "Quantity",
      summaryTitle: "Order summary",
      receiveTitle: "What you'll receive",
      receive: [
        "2 front mats molded to the millimetre for your vehicle",
        "1 one-piece rear mat covering the center tunnel",
        "Factory-compatible installation clips",
        "Installation & care guide",
        "NordiGuard lifetime warranty card",
      ],
      safetyTitle: "Safety instructions",
      safety: [
        "Never stack the mat on top of another mat or a loose factory carpet.",
        "Always secure the driver's mat with the supplied clips before driving.",
        "Make sure no part of the mat interferes with the pedals (brake, accelerator, clutch).",
        "Remove and reinstall the mat properly after every cleaning.",
      ],
      total: "Total", shipping: "Standard shipping", free: "Free", taxNote: "Canadian taxes calculated for your province.",
      subtotal: "Subtotal",
      province: "Province / territory",
      provincePlaceholder: "Select your province…",
      payBtn: "Confirm my order",
      processing: "Placing your order…",
      secureNote: "Interac e-Transfer: instructions sent after confirmation. Cards, PayPal and Apple Pay: encrypted payment, no data stored here.",
      methodTitle: "Payment method",
      methodCard: "Credit card",
      methodCardSub: "Visa, Mastercard, American Express",
      methodInterac: "Interac e-Transfer",
      methodInteracSub: "Simple and free — instructions sent after confirmation",
      methodPaypal: "PayPal",
      methodPaypalSub: "Pay with your PayPal account",
      methodApplePay: "Apple Pay",
      methodApplePaySub: "Fast checkout on iPhone, iPad and Mac",
      methodSoon: "Coming soon",
      paypalHint: "Create your order, then finalize with PayPal below.",
      changeVehicle: "Change",
      errVehicle: "Please select your vehicle make and model.",
      errPay: "Could not place the order. Please try again.",
    },
    success: {
      checking: "Loading your order…",
      eyebrow: "Order confirmed",
      title1: "Your vehicle upgrade",
      title2: "is confirmed.",
      tracker: ["Ordered", "Shipped", "Delivered"],
      greeting: "Hi {name},",
      intro: "Your order has been confirmed — thank you for choosing NordiGuard. Track your order in real time right here.",
      nextTitle: "What's next?",
      next: [
        "Most orders ship within 2 business days.",
        "Every NordiGuard set is laser-molded for your exact vehicle.",
        "Enjoyed the experience? Share NordiGuard with someone who notices the details too.",
      ],
      summaryTitle: "Summary",
      orderNumber: "Order #",
      orderDate: "Order date",
      totalTitle: "Order total",
      homeCta: "Back to home",
      code: "Confirmation code",
      codeNote: "Keep this code — it appears on your invoice and in your confirmation email.",
      invoiceCta: "Download my invoice (PDF)",
      notFound: "Order not found. Check your link or contact us.",
      interacTitle: "Last step: your Interac e-Transfer",
      interacStep1: "Send an Interac e-Transfer of",
      interacStep2: "Write your code in the transfer message:",
      interacStep3: "Production starts upon receipt — tracking follows by email.",
      tracking: "Tracking number",
      liveNote: "This page updates automatically.",
    },
    interac: {
      title: "Interac e-Transfer",
      subtitle: "Order reserved — only the transfer remains.",
      stepBank: "1. Sign in to your bank",
      stepBankSub: "Choose your institution below — a new window opens on its secure sign-in page.",
      stepSend: "2. Send the transfer",
      sendTo: "Recipient",
      sendAmount: "Exact amount",
      sendMessage: "Transfer message (important)",
      stepDone: "3. That's it",
      stepDoneSub: "Production starts upon receipt. Your confirmation and tracking arrive by email.",
      confirmCta: "View my order confirmation",
      secureNote: "You send the transfer on your bank's secure site — NordiGuard never sees your banking details.",
    },
    lang: { label: "FR" },
    admin: {
      title: "Order management",
      subtitle: "NordiGuard private area",
      password: "Admin password",
      login: "Sign in",
      wrong: "Incorrect password",
      logout: "Sign out",
      refresh: "Refresh",
      empty: "No orders yet.",
      status: {
        commandee: "Placed",
        recue: "Paid — in production",
        en_attente_virement: "Awaiting e-Transfer",
        en_attente_paiement: "Awaiting online payment",
        payee: "Paid — in production",
        expediee: "Shipped",
        livree: "Delivered",
      },
      actPaid: "Transfer received",
      actShip: "Mark as shipped",
      actDeliver: "Mark as delivered",
      trackingPlaceholder: "Tracking number (optional)",
      shippedNote: "The customer was notified by email.",
    },
    marketing: {
      tagline: "Customizable 5D PVC Auto Floor Mat with EVA Base for Car Interiors",
    },
  },
};

const LanguageContext = createContext(null);

const get = (obj, path) =>
  path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("nordiguard-lang") || "fr");

  const setLang = (l) => {
    localStorage.setItem("nordiguard-lang", l);
    setLangState(l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path, vars) => {
    let v = get(translations[lang], path);
    if (v === undefined) v = get(translations.fr, path);
    if (typeof v === "string" && vars) {
      Object.entries(vars).forEach(([k, val]) => {
        v = v.replaceAll(`{${k}}`, val);
      });
    }
    return v === undefined ? path : v;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
